import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { DropdownItemModel, SedsSizeOptions } from "@serasa/shared/seds"; // NOSONAR
import { Observable, Subscription } from "rxjs";

import { JustificationsEnum } from "@serasa/shared/enums/justifications.enum";
import { SiteSection } from "@serasa/shared/enums/site-section.enum";
import { AnalyticsService } from "@serasa/shared/services/analytics.service";
import { SidenavManagerService } from "@serasa/shared/services/sidenav.manager.service";

import { selectLogon } from "../../../users/state/selectors/user.selectors";
import { BlockUserFeature } from "../../interfaces/dashboard-state.interface";
import {
  loadBlockUser,
  loadResetBlockUser,
} from "../../state/actions/dashboard.actions";
import { selectBlockUserFeature } from "../../state/selectors/dashboard.selector";

@Component({
    selector: "pl-block-user",
    templateUrl: "./block-user.component.html",
    styleUrls: ["./block-user.component.scss", "../../../../../styles/theme/modal.scss"],
    standalone: false
})
export class BlockUserComponent implements OnInit, OnDestroy {
  public selectedLogon$!: Observable<any>;
  public selectBlockUserFeature$!: Observable<any>;
  public selectedLogon: any = null;

  public justificationList!: DropdownItemModel[];
  public justification!: string;
  public justificationSelected!: any;
  public smallButton = SedsSizeOptions.SMALL;

  public isLoading = false;
  public hasSuccess = false;

  private readonly $sub!: Subscription;

  constructor(
    public store: Store,
    private readonly _analyticsService: AnalyticsService,
    private readonly _sidenavManagerService: SidenavManagerService,
    @Inject(MAT_DIALOG_DATA) public data: { byUserDetails: boolean },
  ) {
    this.selectedLogon$ = this.store.select(selectLogon);
    this.selectBlockUserFeature$ = this.store.select(selectBlockUserFeature);

    this.$sub = this.selectedLogon$.subscribe((logon) => {
      this.selectedLogon = logon;
    });

    this.selectBlockUserFeature$.subscribe(
      (blockResponse: BlockUserFeature) => {
        const { response, error, isLoading } = blockResponse;
        this.isLoading = isLoading;

        if (response && !error) {
          this.hasSuccess = true;
        } else {
          this.hasSuccess = false;
        }
      },
    );
  }

  ngOnInit(): void {
    this._analyticsService.doPageLoad(SiteSection.BLOQUEAR_USUARIO);
    this._initJustificationDropdown();
  }

  public blockUser(): void {
    this.justificationSelected = this.justificationList.find(
      (just) => just.key === this.justification,
    );

    this.store.dispatch(
      loadBlockUser({
        payload: {
          logon: this.selectedLogon?.logon,
          reason: this.justificationSelected?.rawValue,
        },
      }),
    );
  }

  private _initJustificationDropdown(): void {
    this.justificationList = (
      Object.keys(JustificationsEnum) as Array<keyof typeof JustificationsEnum>
    ).map((justification, i) => {
      return {
        key: `${i + 1}`,
        value: JustificationsEnum[justification],
        rawValue: justification,
      };
    });
  }

  ngOnDestroy() {
    this.$sub.unsubscribe();
    this.store.dispatch(
      loadResetBlockUser({ selectedLogon: this.selectedLogon }),
    );

    if (!this.data?.byUserDetails) {
      this._sidenavManagerService.navigate$.next("");
    }
  }
}
